import React from 'react'
import { isFeatureEnabled, serverData, hasTreatmentName } from '../utils'
import { Message } from '@paypalcorp/worldready-react'
import { SHOPPING_PRIVACY_FLOW_REDESIGN } from '../constants/constants'
import { dataPrivacyConfig } from './data-privacy-data-platform'
import { pageSpec } from './fptiConstants'

const enabledForNative = serverData.isNative,
  isPublicProfile = serverData.isPublicProfile,
  isMerchantUser = serverData.isMerchantUser || false,
  enabledForPermission =
    !isMerchantUser && isFeatureEnabled('enabledForPermission'),
  enabledForManageCookies = !enabledForNative,
  enabledForSearchPrivacy =
    isFeatureEnabled('enabledForSearchPrivacy') &&
    (isPublicProfile || hasTreatmentName('Trmt_p2p_discoverabilty_ramp')),
  enabledForMarketing =
    !isMerchantUser && isFeatureEnabled('enabledForMarketing'),
  enabledForShopping =
    !isMerchantUser && isFeatureEnabled('enabledForShopping'),
  enabledForBlockedContacts =
    hasTreatmentName('Trmt_Blocked_Contacts_Controls') &&
    isFeatureEnabled('enabledForBlockedContacts'),
  enabledForManagePrivacySection =
    enabledForPermission ||
    enabledForManageCookies ||
    enabledForMarketing ||
    enabledForShopping ||
    enabledForSearchPrivacy ||
    enabledForBlockedContacts,
  isInFrame = serverData.isInFrame,
  subsectionComponent =
    serverData.selectedComponent === 'dw2' ? 'dw2' : 'default'

const linkClassName = 'nemo-subSection-header subSection-header'
const privacySections = [
  {
    sectionId: 'privacySection',
    sectionName: <Message id="privacy.sectionName" />,
    isEnabled: enabledForManagePrivacySection,
    enabledCountries: [],
    hasElmoTreatment: true,
    subSections: [
      {
        subSectionId: 'permissions',
        title: <Message id="privacy.permissions.title" />,
        desc: <Message id="privacy.permissions.desc" />,
        iconName: dataPrivacyConfig.permission[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForPermission, //rcs service
        navigateTo:
          '/myaccount/security/flow/permissions/thirdparty?flow=cmV0dXJuVXJsPS9teWFjY291bnQvcHJpdmFjeSZjYW5jZWxVcmw9L215YWNjb3VudC9wcml2YWN5',
        fptiClickData: pageSpec.privacy_sections_permissions_given_Link(),
      },
      {
        subSectionId: 'manageCookies',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.cookies.title'
                : 'privacy.manageCookies.title'
            }
          />
        ),
        desc: <Message id="privacy.manageCookies.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.manageCookie[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForManageCookies, //rcs service
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/cookiePrefs?inframe=${isInFrame}`
            : '/myaccount/privacy/cookiePrefs',
        fptiClickData:
          pageSpec.privacy_section_manage_cookie_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.manage" />,
      },
      {
        subSectionId: 'interestMarketing',
        title: <Message id="privacy.marketing.title" />,
        desc: <Message id="privacy.marketing.desc" />,
        iconName: dataPrivacyConfig.marketing[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForMarketing,
        modal: {
          name: 'interestMarketingModal',
        },
        fptiClickData: pageSpec.privacy_section_interest_marketing_link(),
      },
      {
        subSectionId: 'ppShopping',
        title: <Message id="privacy.shopping.title" />,
        desc: <Message id="privacy.shopping.new.desc" />,
        iconName: dataPrivacyConfig.shopping[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForShopping,
        navigateTo: SHOPPING_PRIVACY_FLOW_REDESIGN,
        fptiClickData: pageSpec.privacy_section_pp_shopping_link(),
      },
      {
        subSectionId: 'searchPrivacy',
        title: <Message id="privacy.options.title" />,
        desc: <Message id="privacy.options.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.searchPrivacy[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForSearchPrivacy,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/profiles/search?inframe=${isInFrame}`
            : '/myaccount/privacy/profiles/search',
        fptiClickData:
          pageSpec.privacy_section_search_privacy_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'blockedContacts',
        title: <Message id="privacy.blockedContacts.title" />,
        desc: <Message id="privacy.blockedContacts.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.blockedContacts[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForBlockedContacts,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/transfer/homepage/contact-list/blocked-contacts?inframe=${isInFrame}`
            : '/myaccount/transfer/homepage/contact-list/blocked-contacts',
        fptiClickData:
          pageSpec.privacy_section_blocked_contacts_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.update" />,
      },
    ],
  },
]

export default privacySections
